export enum EnumTerminalStatus {
    Disponivel = 0,
    Ativo = 1,
    Bloqueado = 2,
    Desativado = 3,
}